import axios from 'axios';

export const DOCUMENT_ACCESS_REVOKED_MESSAGE =
    'The owner has revoked sharing for this document. It is no longer available.';

export const isDocumentAccessRevokedError = (error: unknown): boolean =>
    axios.isAxiosError(error) && error.response?.status === 403;
